import React from 'react'
import PropTypes from 'prop-types'
import { Button, Popconfirm, Table } from 'antd'
import { DeleteOutlined, EyeOutlined } from '@ant-design/icons'
import './styles.css'

const { Column } = Table

const ObstacleWorkOrderTable = ({ data, onRemoveObstacleWorkOrder, loading, onEditObstacleWorkOrder }) => {
    return (
        <Table className="reportWorkOrderTableCont" dataSource={data} rowKey="position" size="small" pagination={false} scroll={{ x: 1000 }}>
            <Column title="Número" dataIndex="number" key="number" align="center" width="5%"/>
            <Column title="Fecha" dataIndex="obstacleDate" key="obstacleDate" align="center" width="15%"/>
            <Column title="Descripción" dataIndex="description" key="description" align="center" width="30%"/>
            <Column title="Responsable" dataIndex="responsable" key="responsable" align="center" width="25%"/>
            <Column title="Fecha resolución" dataIndex="endDate" key="endDate" align="center" width="15%"
                render={(text, record) => {
                    if (record.endDate !== '') {
                        return record.endDate
                    } else return <Button onClick={() => onEditObstacleWorkOrder(record)}>Agregar</Button>
                }}
            />
            <Column title="" dataIndex="actions" key="actions" align="center" width="15%" render={(text, record) =>
                <Popconfirm disabled={loading} title="Se borrará la traba, ¿Continuar?"
                            onConfirm={() => onRemoveObstacleWorkOrder(record)}>
                    <Button loading={loading}>{!loading && <DeleteOutlined style={{ color: 'red' }}/>}</Button>
                </Popconfirm>
            }/>
        </Table>
    )
}

ObstacleWorkOrderTable.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool
}

export default ObstacleWorkOrderTable